<template>
  <div style="padding-bottom: 150px; margin-left: 150px" class="centered">
    <div
      style="
        display: flex;
        height: 15px;
        align-items: center;
        margin-top: 25px;
        justify-content: space-between;
        margin-right: 150px;
      "
    >
      <div style="display: flex; margin-right: 100px">
        <p class="rule-title" style="margin-right: 10px">
          <b-icon
            style="margin-right: 10px"
            class="icon-beaut"
            icon="chevron-left"
            font-scale="1"
            @click="() => this.$router.go(-1)"
          ></b-icon>
        </p>
        <p class="rule-title">
          {{ dataTable.title }}
        </p>
      </div>
      <el-button
        v-if="
          !dataTable.button ||
          dataTable.tables[0].data.length < dataTable.button.trigger
        "
        style="margin-top: -15px"
        @click="
          () => {
            flag = 'insert';
            values['value_a'] = null;
            values['value_b'] = null;
            values['value_c'] = null;
            drawer = true;
          }
        "
        >Adicionar</el-button
      >
    </div>
    <div
      style="
        display: flex;
        margin-left: 40px;
        margin-top: 5px;
        margin-right: 230px;
      "
    >
      <p class="rule-subtitle">
        {{ dataTable.subtitle }}
      </p>
    </div>
    <div
      class=""
      style="margin-top: 40px; margin-left: 32px"
      v-for="(table, index) in dataTable.tables"
      :key="index + table.title"
    >
      <div class="header-title">
        <p class="title_">{{ table.title }}</p>
      </div>
      <div
        class="table-teste"
        style="margin-top: -20px"
        v-if="
          finishedLoad && dataTable.tables.some(({ data }) => data.length > 0)
        "
      >
        <el-table
          :highlight-current-row="true"
          :header-cell-style="{ color: '#333' }"
          :data="table.data"
          style="width: 100%"
        >
          <template>
            <el-table-column
              v-for="(col, index) in table.columns"
              :label="col.label"
              :key="`tb-${index}-${col['value']}`"
            >
              <template slot-scope="scope">
                <span v-if="scope.row[col['key']] === col['value']">{{
                  col["placeholder"]
                }}</span>
                <span v-else-if="scope.row[col['key']] === null"
                  >Não preenchido</span
                >
                <span v-else-if="col.type === 'status'">
                  <span v-if="scope.row[col['key']] === 'true'">Elegível</span>
                  <span v-else>Não elegível</span>
                </span>
                <span v-else-if="col.type === 'status_to_used_money'">
                  <span v-if="scope.row[col['key']] === 'true'">Sim</span>
                  <span v-else>Não</span>
                </span>
                <span v-else-if="col.type === 'percent'">
                  {{ scope.row[col["key"]] }}%
                </span>
                <span v-else>{{
                  col["convert"] !== undefined
                    ? collumnParser(
                        col["convert"].method,
                        scope.row[col["key"]]
                      )
                    : scope.row[col["key"]]
                }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="Ações"
            v-if="
              table.actions &&
              table.actions === 'edit_remove' &&
              !ruleIsDisabled
            "
          >
            <template slot-scope="scope">
              <el-popover
                placement="top"
                width="350"
                v-model="scope.row.popVisible"
                :ref="'popover' + scope.$index"
              >
                <div class="confirm-items">
                  <div>
                    <b-icon
                      style="
                        margin-left: 10px;
                        margin-right: 10px;
                        color: #e87305;
                      "
                      class="icon-beaut"
                      icon="info-circle-fill"
                      font-scale="1"
                    ></b-icon>
                  </div>
                  <div>
                    <span style="word-break: break-word">Excluir</span>
                    <p
                      style="
                        word-break: break-word;
                        margin-top: 10px;
                        font-size: 12px;
                      "
                    >
                      Deseja excluir este item e alterar as regras do rateio?
                    </p>
                  </div>
                </div>

                <div style="text-align: right; margin: 0; margin-top: 5px">
                  <el-button
                    style="background: #eaeaea; color: #515151"
                    type="text"
                    :disabled="isLoadingBtnRemove"
                    @click="scope.row.popVisible = false"
                    >cancelar</el-button
                  >
                  <el-button
                    :loading="isLoadingBtnRemove"
                    @click="handleDelete(scope.row)"
                    >confirmar</el-button
                  >
                </div>
                <el-tooltip
                  slot="reference"
                  content="Excluir regra"
                  placement="left"
                >
                  <b-icon class="icon-beaut" icon="x" font-scale="2"></b-icon>
                </el-tooltip>
              </el-popover>
              <el-tooltip
                slot="reference"
                content="Editar regra"
                placement="right"
              >
                <b-icon
                  class="icon-beaut"
                  style="width: 18px; height: 26px; margin-left: 5px"
                  icon="pencil"
                  font-scale="1.3"
                  @click="handleEdit(scope.row)"
                />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="Ações" v-else-if="!ruleIsDisabled">
            <template slot-scope="scope">
              <el-tooltip
                slot="reference"
                content="Editar regra"
                placement="right"
              >
                <b-icon
                  class="icon-beaut"
                  style="width: 18px; height: 28px; margin-left: 5px"
                  icon="pencil"
                  font-scale="1.2"
                  @click="handleEdit(scope.row)"
                />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          v-if="!finishedLoad"
          :rows="5"
          animated
          style="width: 90%"
        />
        <span v-else>Sem dados para exibir.</span>
      </div>
    </div>
    <el-drawer
      :title="getDrawerTitle"
      :visible.sync="drawer"
      :direction="direction"
      :wrapperClosable="false"
    >
      <div class="drawer">
        <div class="drawer-text-header">
          <span class="drawer-text-title">{{ dataTable.drawer.subtitle }}</span>
        </div>
        <div class="drawer-content">
          <div style="display: flex; flex-direction: column; margin-top: -40px">
            <div
              v-for="(item, index) in dataTable.drawer.form"
              :key="index + item.label"
            >
              <div style="margin-top: 30px">
                <div style="margin-bottom: 10px">
                  <span
                    class="drawer-text-title"
                    style="font-size: 12px !important; margin-bottom: 20px"
                    >{{ item.label }}</span
                  >
                </div>
                <div class="drawer-inner-content">
                  <div v-if="item.type === 'text'">
                    <input
                      type="text"
                      class="text-input"
                      id="pInputText"
                      maxlength="40"
                      v-model="values[item.key]"
                      :placeholder="values[item.key] || item.placeholder"
                    />
                  </div>

                  <div v-if="item.type === 'status'">
                    <input
                      type="text"
                      autocomplete="off"
                      list="browsers-eligibility"
                      class="text-input"
                      :name="`eligibility-${item.key}`"
                      id="pInputValueEligibility"
                      v-model="values[item.key]"
                      :placeholder="values[item.key] || item.placeholder"
                    />
                    <div class="dropdown-container">
                      <datalist id="browsers-eligibility">
                        <option value="Elegível">Elegível</option>
                        <option value="Não elegível">Não elegível</option>
                      </datalist>
                    </div>
                  </div>

                  <div v-if="item.type === 'priority'">
                    <el-input
                      id="inputDrawer"
                      style="width: 80px; margin-right: 10px"
                      type="text"
                      size="medium"
                      v-model="values[item.key]"
                      :placeholder="item.placeholder"
                    >
                    </el-input>
                    <span style="font-size: 12px">º</span>
                  </div>

                  <div v-if="item.type === 'status_to_used_money'">
                    <input
                      type="text"
                      autocomplete="off"
                      list="browsers-status_to_used_money"
                      class="text-input"
                      :name="`listStatusUsedMoney-${item.key}`"
                      id="pInputValueStatusUsedMoney"
                      v-model="values[item.key]"
                      :placeholder="values[item.key] || item.placeholder"
                    />
                    <div class="dropdown-container">
                      <datalist id="browsers-status_to_used_money">
                        <option value="Sim">Sim</option>
                        <option value="Não">Não</option>
                      </datalist>
                    </div>
                  </div>

                  <div v-if="item.type === 'numberOfAreas'">
                    <el-input
                      id="inputDrawer"
                      style="width: 130px; margin-right: 10px"
                      type="number"
                      size="medium"
                      min="1"
                      max="100"
                      v-model="values[item.key]"
                      :placeholder="item.placeholder"
                    >
                    </el-input>
                    <span style="font-size: 12px">áreas</span>
                  </div>

                  <div v-if="item.type === 'percent'">
                    <el-input
                      id="inputDrawer"
                      style="width: 130px; margin-right: 10px"
                      type="number"
                      size="medium"
                      min="1"
                      max="100"
                      v-model="values[item.key]"
                      :placeholder="item.placeholder"
                    >
                    </el-input>
                    <span style="font-size: 12px">%</span>
                  </div>

                  <div v-if="item.type === 'list'">
                    <input
                      type="text"
                      autocomplete="off"
                      list="browsers"
                      class="text-input"
                      @input="checkCCName(item.key)"
                      v-model="values[item.key]"
                      :placeholder="values[item.key] || item.placeholder"
                    />
                    <div class="dropdown-container">
                      <datalist id="browsers">
                        <option
                          v-for="(item, index) in costCenters"
                          :key="`costCenter-${index}`"
                        >
                          {{ item.value }}-{{ item.name }}
                        </option>
                      </datalist>
                    </div>
                  </div>

                  <div v-if="item.type === 'list_collaborator'">
                    <input
                      type="text"
                      autocomplete="off"
                      list="browsers-collab"
                      class="text-input"
                      v-model="values[item.key]"
                      :placeholder="values[item.key] || item.placeholder"
                    />
                    <div class="dropdown-container">
                      <datalist id="browsers-collab">
                        <option
                          v-for="(item, index) in collaborators"
                          :key="`collab-${index}`"
                        >
                          {{ item.name }}
                        </option>
                      </datalist>
                    </div>
                  </div>
                </div>
                <div class="item-info" v-if="item.info">
                  <span>{{ item.info }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="drawer-footer">
            <el-button
              style="background: #eaeaea; color: #515151"
              type="text"
              @click="handleDrawerCancel()"
              >cancelar</el-button
            >
            <el-button
              @click="
                () => {
                  if (flag === 'update') {
                    updateRule();
                  } else {
                    saveRule();
                  }
                }
              "
              >{{ flag === "update" ? "Atualizar" : "Salvar" }}</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<style scoped>
.text-input {
  padding: 7px;
  padding-left: 12px;
  font-size: 14px;
  color: #555;
  font-weight: normal;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  outline: none;
}

.text-input:hover {
  border: 1px solid #e87305;
}

.text-input:focus {
  border: 1px solid #e87305;
}

.item-info {
  color: #e87305;
  font-size: 11px;
  margin-top: 10px;
}

.rule-title {
  font-size: 18px;
  font-weight: bold;
}
.rule-subtitle {
  font-size: 14px;
}
.center_ {
  margin-left: 17%;
  max-width: 900px;
  margin-top: 10px;
  display: flex;
  margin-bottom: 30px;
  align-items: center;
  justify-content: space-between;
}

.dropdown-container select {
  -moz-appearance: none;
  -webkit-appearance: none;
}
.dropdown-container select::-ms-expand {
  display: none;
}

datalist {
  position: absolute;
  background-color: white;
  border: 1px solid blue;
  border-radius: 0 0 5px 5px;
  border-top: none;
  font-family: sans-serif;
  width: 350px;
  padding: 5px;
}

option {
  background-color: white;
  padding: 4px;
  color: blue;
  margin-bottom: 1px;
  font-size: 18px;
  cursor: pointer;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";

import rulesStruct from "../utils/rules/index";
import api from "../utils/api";

import dayjs from "../utils/dayjs";

export default {
  name: "Rule",
  data() {
    return {
      finishedLoad: false,
      isLoadingBtnRemove: false,
      locationId: null,
      direction: "rtl",
      dataTable: [],
      drawer: false,
      costCenters: [],
      collaborators: [],
      currentRule: "",
      flag: "insert",
      values: {
        value_a: null,
        value_b: null,
        value_c: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getLocationId",
      "getCollaborators",
      "getCostCenters",
      "getRulesMonth",
    ]),
    ruleIsDisabled() {
      return dayjs(this.getRulesMonth)
        .startOf("month")
        .isBefore(dayjs().startOf("month"))
        ? true
        : false;
    },
    getDrawerTitle() {
      let res =
        this.flag === "update"
          ? this.dataTable.drawer.title.update_label
          : this.dataTable.drawer.title.insert_label;

      return res || "Gerenciamento da Regra";
    },
  },
  async created() {
    this.updateNavCurrentIndex("6");
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.getData().then(() => {
      this.finishedLoad = true;
    });
    this.updateNavItems_(array_teste);
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
  },
  methods: {
    ...mapActions(["updateNavItems", "updateNavCurrentIndex"]),
    checkCCName(key) {
      this.values = this.handleValues(this.values, key, true);
    },
    collumnParser(method, value) {
      if (method === "project_id_to_id_name") {
        const obj = this.costCenters.find((e) => e.cost_center === value);
        if (typeof obj !== "undefined") {
          return obj.name;
        }
      }
      return "";
    },
    handleDelete(row) {
      this.isLoadingBtnRemove = true;
      api
        .delete(`/deleteRule/${row.id}`)
        .then(({ data }) => {
          if (data) {
            this.getData();
            this.$message({
              type: "success",
              message: "Removido com sucesso!",
            });
          } else {
            this.$message({
              type: "error",
              showClose: true,
              message: "Falha ao tentar remover regra.",
              title: data,
            });
          }
          this.isLoadingBtnRemove = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            showClose: true,
            message: "Falha ao tentar remover regra.",
            title: error.response.data.error,
          });
          this.isLoadingBtnRemove = false;
        });
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleDrawerCancel() {
      this.drawer = false;
    },
    saveRule() {
      this.$confirm(
        "Deseja salvar as alterações realizadas nas regras do rateio?",
        "Inserir regra",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
        }
      )
        .then(() => {
          this.preload();
        })
        .catch(() => {});
    },
    async preload() {
      if (this.dataTable.convert) {
        const valuesTemp = JSON.parse(JSON.stringify(this.values));
        if (this.dataTable.convert.method === "collaborator_registration") {
          const obj = this.collaborators.find(
            (e) => e.name === valuesTemp[this.dataTable.convert.param]
          );
          valuesTemp[this.dataTable.convert.param] = obj
            ? obj.registration
            : "*";
          this.values = valuesTemp;
          if (this.flag === "update") {
            this.dispatchUpdate();
          } else {
            this.dispatch();
          }
        } else if (this.dataTable.convert.method === "boolean_to_yes_or_no") {
          valuesTemp[this.dataTable.convert.param] =
            valuesTemp[this.dataTable.convert.param] === "Sim"
              ? "true"
              : "false";
          this.values = valuesTemp;
          if (this.flag === "update") {
            this.dispatchUpdate();
          } else {
            this.dispatch();
          }
        } else if (this.dataTable.convert.method === "eligibility_to_status") {
          valuesTemp[this.dataTable.convert.param] =
            valuesTemp[this.dataTable.convert.param] === "Elegível"
              ? "true"
              : "false";
          this.values = valuesTemp;
          if (this.flag === "update") {
            this.dispatchUpdate();
          } else {
            this.dispatch();
          }
        }
      } else {
        if (this.flag === "update") {
          this.dispatchUpdate();
        } else {
          this.dispatch();
        }
      }
    },
    handleValues(values, key = null, checkHifen) {
      let defaults = this.dataTable["default"] || {};

      const getValue = (key) => {
        let value = null;
        if (values[key] === "" || values[key] === null) {
          value = defaults[key] || null;
        } else {
          value = values[key];

          if (checkHifen) {
            let idx = values[key].indexOf("-");
            if (idx != -1) {
              value = values[key].substr(0, idx);
            }
          }
        }
        return value;
      };
      if (key) {
        return {
          ...values,
          key: getValue(key),
        };
      } else {
        return {
          ...values,
          value_a: getValue("value_a"),
          value_b: getValue("value_b"),
          value_c: getValue("value_c"),
        };
      }
    },
    dispatch() {
      this.values = this.handleValues(this.values, false, true);

      api
        .post("/insertRules", [
          {
            token: this.$route.params.token,
            locale: this.locationId,
            value_a: this.values.value_a,
            value_b: this.values.value_b,
            value_c: this.values.value_c,
          },
        ])
        .then(() => {
          this.drawer = false;
          this.getData();
          this.$message({
            type: "success",
            message: "Nova regra inserida!",
          });
          for (const key in this.values) {
            this.values[key] = null;
          }
        })
        .catch((error) => {
          this.drawer = false;
          this.$message({
            type: "error",
            showClose: true,
            message: error.response.data.error,
            title: error.response.data.error,
          });
        });
    },
    dispatchUpdate() {
      const valuesTemp = JSON.parse(
        JSON.stringify(this.handleValues(this.values, false, true))
      );

      api
        .put(`/updateRule/${this.currentRule}`, {
          token: this.$route.params.token,
          locale: this.locationId,
          value_a: valuesTemp.value_a,
          value_b: valuesTemp.value_b,
          value_c: valuesTemp.value_c,
        })
        .then(() => {
          this.getData();
          this.$message({
            type: "success",
            message: "Regra atualizada!",
          });
          this.drawer = false;
          for (const key in this.values) {
            this.values[key] = null;
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            showClose: true,
            message: error.response.data.error,
            title: error.response.data.error,
          });
        });
    },
    updateRule() {
      this.$confirm(
        "Deseja salvar as alterações realizadas nas regras do rateio?",
        "Atualizar informações",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
        }
      )
        .then(() => {
          this.preload();
        })
        .catch(() => {});
    },
    transformValue(value, method) {
      if (method === "boolean_to_eligibility_status") {
        return value === "true" ? "Elegível" : "Não elegível";
      } else if (method === "boolean_to_yes_or_no") {
        return value === "true" ? "Sim" : "Não";
      } else {
        return value;
      }
    },
    getScreenValue(value, key) {
      const findMethod = this.dataTable.drawer.form.find((e) => e.key === key);
      try {
        if (findMethod.convert) {
          return this.transformValue(value, findMethod.convert.method);
        }
        return value;
      } catch (error) {
        return value;
      }
    },
    handleEdit(row) {
      for (const key in this.values) {
        this.values[key] = this.getScreenValue(row[key], key);
      }
      this.flag = "update";
      this.currentRule = row.id;
      this.drawer = true;
    },
    handleCollaborators() {
      this.collaborators = this.getCollaborators
        .map((e) => {
          return {
            ...e,
            value: e.cost_center,
            label: e.cost_center,
          };
        })
        .sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
    },
    handleCostCenters() {
      this.costCenters = this.getCostCenters
        .map((e) => {
          return {
            ...e,
            value: e.cost_center,
            label: e.cost_center,
          };
        })
        .sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
    },
    getStructTableByRulesConfiguration() {
      this.dataTable = rulesStruct.filter(
        (e) => e.token === this.$route.params.token
      )[0];
    },
    insertRulesInTable(data) {
      this.dataTable.tables = this.dataTable.tables.map((e) => {
        return { ...e, data: [] };
      });

      for (let element of data) {
        for (let index in this.dataTable.tables) {
          let tableType = this.dataTable.tables[index].type;
          let obj = element;

          let arr_collab_tokens = [
            "collab_allocation_not_in_proj",
            "collab_allocation_in_proj",
            "max_percent_salary_in_apportionment",
          ];
          if (arr_collab_tokens.includes(element.token)) {
            let collab = this.collaborators.find(
              (e) => element["value_a"] === e.registration
            ) || { name: "" };
            obj = {
              ...element,
              value_a:
                collab.name ||
                (element["value_a"] !== "*"
                  ? `${element["value_a"]} (não encontrado)`
                  : element["value_a"]),
            };
          }

          let arr_collab_exceptions = [
            "collab_max_allocation_in_proj",
            "max_percent_salary_in_apportionment",
          ];
          if (arr_collab_exceptions.includes(element.token)) {
            if (
              (tableType === "general" &&
                element[this.dataTable.paramsVerify.param] ===
                  this.dataTable.paramsVerify.value) ||
              (tableType === "exception" &&
                element[this.dataTable.paramsVerify.param] !==
                  this.dataTable.paramsVerify.value)
            ) {
              this.dataTable.tables[index].data.push(obj);
            }
          } else {
            this.dataTable.tables[index].data.push(obj);
          }
        }
      }
    },
    async getData() {
      this.getStructTableByRulesConfiguration();
      const data = await api
        .get("/findRules", {
          params: {
            locale: this.locationId,
            token: this.$route.params.token,
            month: new Date(this.getRulesMonth).toISOString(),
          },
        })
        .then(({ data }) => {
          const orderBy = this.dataTable.orderBy;

          if ([null, undefined, ""].includes(data) || !orderBy) {
            return data;
          } else {
            return data.sort((a, b) =>
              a[orderBy] === null
                ? 1
                : a[orderBy].localeCompare(b[orderBy], "pt", { numeric: true })
            );
          }
        });

      this.handleCollaborators();
      this.handleCostCenters();
      this.insertRulesInTable(data);
    },
  },
};
</script>
